<template>
  <div style="display: flex; align-items: center">
    <v-autocomplete
      :items="userList"
      :loading="loading"
      item-text="title"
      item-value="id"
      solo
      hide-no-data
      hide-selected
      label="Personel Ara"
      :model-value="props.modelValue"
      @update:model-value="handleModelValue"
      v-model:search="searchTerm"
      @update:search="handleSearch"
    ></v-autocomplete>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "UserSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const store = useStore();
    const searchTerm = ref("");
    
    const userList = computed(() => store.state.userList);
    const loading = computed(() => store.state.loading);

    const handleSearch = debounce((term) => {
      if (term && term.length >= 2) {
        store.dispatch("fetchUserList", term);
      }
    }, 300);

    const handleModelValue = (value) => {
      emit('update:modelValue', value);
    };

    const addUser = () => {
      console.log("Yeni personel ekle!");
    };

    return {
      props,
      searchTerm,
      userList,
      loading,
      handleSearch,
      handleModelValue,
      addUser,
    };
  },
};
</script>